export const ExportType = {
  LIST: 'list',
  SURVEY_TYPE_A: 'survey_type_a',
  SURVEY_TYPE_Q: 'survey_type_q'
} as const;
